// Funktionsschalter „Bestandsführung“ (Modul inventory, Schlüssel 'stock', Vorgabe an) und die EINE Regel, ob ein Artikel
// wirksam im Bestand geführt wird – für Server und Oberfläche (docs/ohne-lager/SPEZIFIKATION.md).
//
// Ist der Schalter aus, gelten Artikel als nicht bestandsgeführt: Aufträge reservieren nicht, Lieferscheine, Kasse und
// Rücknahmen buchen keinen Bestand, Verfügbarkeit ist kein Hindernis. Das gespeicherte Merkmal am Artikel
// (`item.stock_managed`) bleibt unverändert – wer wieder einschaltet, bekommt den alten Zustand zurück.
// Ausnahme: Leihartikel. Der Verleih zählt seine Geräte über den Bestand – sie bleiben nach ihrem Merkmal geführt.
// Auf dem Server fragt man den Kern (`ledger.stockEnabled`, `ledger.isStockManaged`, `ledger.stockManagedSql`).

/** Schlüssel des Funktionsschalters „Bestandsführung“ */
export const STOCK_FEATURE = 'stock'

/** Art der Leihartikel (`item.kind`): Sie bleiben auch ohne Bestandsführung des Betriebs bestandsgeführt. */
export const RENTAL_ITEM_KIND = 'rental'

/** Wird der Artikel wirksam im Bestand geführt? Merkmal am Artikel UND (Bestandsführung an ODER Leihartikel). */
export function effectiveStockManaged(
  item: { readonly stockManaged: boolean; readonly kind: string },
  stockEnabled: boolean,
): boolean {
  return item.stockManaged && (stockEnabled || item.kind === RENTAL_ITEM_KIND)
}
